<template>
  <Layout class="content-sm">
    <!-- <Sider hide-trigger :style="{background: '#fff'}">
      <Menu active-name="1-2" theme="light" width="auto" :open-names="['1']">
        <MenuItem name="1-1">Option 1</MenuItem>
        <MenuItem name="1-2">Option 2</MenuItem>
        <MenuItem name="1-3">Option 3</MenuItem>
      </Menu>
    </Sider> -->
    <Content>
      <h2>
        <Icon type="ios-people"/>
        Sezione Soci
      </h2>

      Vai a:
      &nbsp;
      <a href="#/tessere">gestione tipologie di tessere</a>
      &nbsp;
      |
      &nbsp;
      <a v-if="$store.company.slug" :href="`/#/registrazione/${$store.company.slug}`">registrazione rapida</a>
      <br>
      <br>
      <router-view/>
    </Content>
  </Layout>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'soci-layout',
  components: {
    HelloWorld
  }
}
</script>
